import { createContext, useContext } from "react";
import type {
	ActiveDialog,
	DialogName,
	DialogOptionsMap,
	ShowDialogBehavior,
} from "./types";

type DialogContextValue = {
	showDialog: <K extends DialogName>(
		name: K,
		options: DialogOptionsMap[K],
		behavior?: ShowDialogBehavior,
	) => void;
	hideDialog: (name?: DialogName) => void;
	active: ActiveDialog;
};

export const DialogContext = createContext<DialogContextValue | null>(null);

export const useDialog = () => {
	const context = useContext(DialogContext);
	if (!context) {
		throw new Error("useDialog must be used within a DialogProvider");
	}
	return context;
};
